
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Puzzle from "../../modules/puzzle/Puzzle";
import { puzzleApi } from "../../services/api";
async function getStaticProps() {
    let puzzles: unknown[] = [];
    let nextPuzzleId: number | null = null;
    try {
        const response = await puzzleApi.get("/puzzles");
        puzzles = Array.isArray(response?.data?.puzzles) ? response.data.puzzles : [];
        const randomPuzzleId = Number(response?.data?.nextPuzzleId);
        nextPuzzleId =
            Number.isInteger(randomPuzzleId) && randomPuzzleId > 0
                ? randomPuzzleId
                : null;
    }
    catch (e) {
        console.log("Error in puzzles index");
    }
    return {
        props: {
            puzzles,
            nextPuzzleId,
            index: true,
        },
        revalidate: puzzles.length > 0 ? 86400 : 300,
    };
}
export default Puzzle;

    async function __Next_Translate__getStaticProps__1a179dc9089__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/puzzle/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a179dc9089__ as getStaticProps }
  